import { useRef as c, useContext as $, useState as k, useEffect as q } from "react";
import { useForkRef as D, useSafeLayoutEffect as S, useWrapElement as j } from "../../../ariakit-react-utils/esm/hooks.js";
import { setRef as y } from "../../../ariakit-react-utils/esm/misc.js";
import { createHook as A, createComponent as M, createElement as w } from "../../../ariakit-react-utils/esm/system.js";
import { getDocument as N } from "../../../ariakit-utils/esm/dom.js";
import { isFocusEventOutside as a } from "../../../ariakit-utils/esm/events.js";
import { getNextTabbable as h, getPreviousTabbable as I, restoreFocusIn as H, disableFocusIn as V } from "../../../ariakit-utils/esm/focus.js";
import { queueMicrotask as W } from "../../../ariakit-utils/esm/misc.js";
import { createPortal as _ } from "react-dom";
import { PortalContext as C } from "./portal-context.js";
import { jsx as f, jsxs as L, Fragment as O } from "react/jsx-runtime";
import { FocusTrap as m } from "../focus-trap/focus-trap.js";
function z(o) {
  return N(o).body;
}
function B(o, n) {
  return n ? typeof n == "function" ? n(o) : n : N(o).createElement("div");
}
function G(o) {
  return o === void 0 && (o = "id"), `${o ? `${o}-` : ""}${Math.random().toString(36).substr(2, 6)}`;
}
function i(o) {
  W(() => {
    o == null || o.focus();
  });
}
const J = A((o) => {
  let {
    preserveTabOrder: n,
    portalElement: b,
    portalRef: p,
    portal: l = !0,
    ...s
  } = o;
  const P = c(null), g = D(P, s.ref), d = $(C), [r, E] = k(null), R = c(null), v = c(null), F = c(null), x = c(null);
  return S(() => {
    const e = P.current;
    if (!e || !l) {
      E(null);
      return;
    }
    const t = B(e, b);
    if (!t) {
      E(null);
      return;
    }
    const u = t.isConnected;
    if (u || (d || z(e)).appendChild(t), t.id || (t.id = e.id ? `${e.id}-portal` : G()), E(t), y(p, t), !u)
      return () => {
        t.remove(), y(p, null);
      };
  }, [l, b, d, p]), q(() => {
    if (!r || !n) return;
    let e = 0;
    const t = (u) => {
      if (a(u)) {
        if (u.type === "focusin") return H(r);
        cancelAnimationFrame(e), e = requestAnimationFrame(() => {
          V(r, !0);
        });
      }
    };
    return r.addEventListener("focusin", t, !0), r.addEventListener("focusout", t, !0), () => {
      r.removeEventListener("focusin", t, !0), r.removeEventListener("focusout", t, !0);
    };
  }, [r, n]), s = j(s, (e) => (e = // While the portal node is not in the DOM, we need to pass the
  // current context to the portal context, otherwise it's going to
  // reset to the body element on nested portals.
  /* @__PURE__ */ f(C.Provider, {
    value: r || d,
    children: e
  }), l ? r ? (e = /* @__PURE__ */ L(O, {
    children: [n && r && /* @__PURE__ */ f(m, {
      ref: v,
      onFocus: (t) => {
        if (a(t, r)) {
          const u = h();
          u !== F.current && i(u);
        } else
          i(R.current);
      }
    }), e, n && r && /* @__PURE__ */ f(m, {
      ref: F,
      onFocus: (t) => {
        if (a(t, r)) {
          const u = I();
          u !== v.current && i(u);
        } else
          i(x.current);
      }
    })]
  }), r && (e = /* @__PURE__ */ _(e, r)), e = /* @__PURE__ */ L(O, {
    children: [n && r && /* @__PURE__ */ f(m, {
      ref: R,
      onFocus: (t) => {
        a(t, r) ? i(v.current) : i(I());
      }
    }), n && // We're using position: fixed here so that the browser doesn't
    // add margin to the element when setting gap on a parent element.
    /* @__PURE__ */ f("span", {
      "aria-owns": r == null ? void 0 : r.id,
      style: {
        position: "fixed"
      }
    }), e, n && r && /* @__PURE__ */ f(m, {
      ref: x,
      onFocus: (t) => {
        a(t, r) ? i(F.current) : i(h());
      }
    })]
  }), e) : /* @__PURE__ */ f("span", {
    ref: g,
    id: s.id,
    style: {
      position: "fixed"
    }
  }) : e), [r, d, l, s.id, n]), s = {
    ...s,
    ref: g
  }, s;
}), K = M((o) => {
  const n = J(o);
  return w("div", n);
});
process.env.NODE_ENV !== "production" && (K.displayName = "Portal");
export {
  K as Portal,
  J as usePortal
};
//# sourceMappingURL=portal.js.map
